import React, { useCallback, useEffect, useState } from 'react';
import Box from "@mui/material/Box"
import { useInfoStore } from "../store/userInfo";
import { ButtonBase, Stack, Typography, keyframes } from "@mui/material";
import styled from "@emotion/styled";
// import global from "../assets/images/global.svg";
// import cart from "../assets/images/cart.svg";
// import bill from "../assets/images/bill.svg";
// import ellipse_w from "../assets/images/ellipse_w.svg";
import { useOrderStore } from "../store/order";
import './Components.css'
import { getCheckBill } from '../services/order.service';
import './Button.css'
import { useWindowDimensions } from '../App';
import { getTableUserSettings } from '../services/setting.service';
import { logger } from "../utils/logger";
import { devLog } from '../utils/logger';


const blink = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const BlinkedBox = styled('div')({
  // backgroundColor: 'red',
  // width: {md:'289px',lg:'337px'},
  // height: {md:'76px',lg: '88px'},
  animation: `${blink} 1s linear infinite`,
});

// 버튼 컴포넌트들을 별도로 분리 (React.memo로 최적화)
const ActionButtons = React.memo(({ 
  isKiosk, 
  publicSettings, 
  isSettingsLoaded, 
  landMode, 
  handleOpenLanguageMenu, 
  handleOpenServerCall, 
  handleOpenOrderList 
}: {
  isKiosk: boolean;
  publicSettings: any;
  isSettingsLoaded: boolean;
  landMode: boolean;
  handleOpenLanguageMenu: (e: any) => void;
  handleOpenServerCall: (e: any) => void;
  handleOpenOrderList: (e: any) => void;
}) => {
  
  return (
    <>
      <ButtonBase sx={{backgroundColor: '#000', borderRadius : '1.5rem 1.5rem 0rem 0rem', padding: '1.4rem 2rem', width: landMode ? '18.3rem': '13.2rem', height: landMode? '5.8rem': '4.4rem', display: 'flex', flexDirection: 'row', textTransform: 'none',
        alignItems: 'center', justifyContent: 'center', touchAction: 'none'}} onTouchEnd={(e) => handleOpenLanguageMenu(e)} onClick={(e) => handleOpenLanguageMenu(e)}>
        <Typography sx={{color: '#fff', fontSize: landMode ? '2rem': '1.6rem', fontStyle: 'normal', fontWeight: '600', lineHeight: 'normal', mr: '1rem', mb: 0}}>Language</Typography>
        <img style={{width: landMode ? '3rem': '1.8rem', height: landMode ? '3rem': '1.8rem'}}
          src={process.env.PUBLIC_URL+'/assets/images/global.svg'}
          alt="global"
        />
      </ButtonBase>
      
      {isSettingsLoaded && publicSettings?.useCall &&  !isKiosk && (
        <ButtonBase sx={[{ backgroundColor: '#000', borderRadius : '1.5rem 1.5rem 0rem 0rem', padding: landMode ?'1.4rem 2rem': '1rem 1.4rem', width: landMode ? '18rem': '11.6rem', height: landMode? '5.8rem': '4.4rem',  justifyContent: 'center',alignItems: 'center', textTransform: 'none'}]}
          onClick={(e) => handleOpenServerCall(e)} onTouchEnd={(e) => handleOpenServerCall(e)}>
          <Typography sx={{color: '#fff', fontSize: landMode ? '2rem': '1.6rem', fontStyle: 'normal', fontWeight: '600', mb: 0}}>Call Server</Typography>
        </ButtonBase>
      )}
      
      {isSettingsLoaded && publicSettings?.useCheck && !isKiosk && (
        <ButtonBase sx={[ {backgroundColor: '#000',borderRadius : '1.5rem 1.5rem 0rem 0rem', padding: '1.4rem 2rem', width: landMode ?'17.5rem': '13.6rem', height: landMode? '5.8rem': '4.4rem', justifyContent: 'center', textTransform: 'none',}]}
          onClick={(e) => handleOpenOrderList(e)} onTouchEnd={(e) => handleOpenOrderList(e)}>
          <Typography sx={{color: '#fff', fontSize: landMode ? '2rem': '1.6rem', fontStyle: 'normal', fontWeight: '600', mb: 0}}>Check</Typography>
          <img style={{marginLeft: "1.4rem", width: landMode ? '3rem': '1.8rem', height: landMode ? '3rem': '1.8rem'}}
            src={process.env.PUBLIC_URL+'/assets/images/bill.svg'}
            alt="global"
          />
        </ButtonBase>
      )}
    </>
  );
});

const BottomMenu = () => {
  const { tableInfo, userInfo } = useInfoStore();
  const { orientation } = useWindowDimensions();
  const storeId = userInfo?.storeId
  const isKiosk = tableInfo.isKioskMode;
  const { setOpenCart, totalCount, orderList, setSnackMode, setShowSnackbar, setOrderList, setOpenOrderList, setOpenServerCall, setOpenLanguageMenu } = useOrderStore();
  const [loadOrder, setLoadOrder] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const landMode = (orientation === "landscape") ?true: false
  const [publicSettings, setPublicSettings] = useState<any>(null)
  const [isSettingsLoaded, setIsSettingsLoaded] = useState(false)

  const loadPublicSettings = useCallback(async () => {
    if(!storeId) return;
    const res = await getTableUserSettings(storeId)
    if(res.status === 200) {
      devLog('publicSettings', res.data)
      setPublicSettings(res.data)
      setIsSettingsLoaded(true)
    }
  }, [storeId]);

  useEffect(() => {
    loadPublicSettings()
  }, [loadPublicSettings])

  const debounce = (func: { (e: any): Promise<void>; apply?: any; }, delay: number | undefined) => {
    let debounceTimer: string | number | NodeJS.Timeout | undefined;
    return (...args: any) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(this, args), delay);
    };
  };
  
  const handleOpenCart = (e: React.TouchEvent<HTMLButtonElement> | React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    logger.debug('open')
    e.stopPropagation();
    e.preventDefault()
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    setOpenCart(true)
   }
 
  // const handleOpenOrderList = async (e: React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent> | React.TouchEvent<HTMLButtonElement>) => {
  //   // e.stopPropagation();
  //   e.preventDefault()
  //   if(loadOrder) return 
  //   await getCheckBill(tableInfo.id).then(
  //     (res: { status: number; data: React.SetStateAction<JSON>; }) => {
  //       if(res.status === 200 || res.status === 201) {
  //         console.log(res.data)
  //         setOrderList(res.data);
  //         setLoadOrder(true)
  //         // if(res.data.orderDetails === undefined) {
  //         //   setShowSnack(true)
  //         //   setTimeout(() => {
  //         //     closeDialog()
  //         //   }, 2000)
  //         // }
  //         console.log("order History")
  //       }
  //     },
  //     (error: any) => {
  //       console.log("error",error)
  //     }
  //   )

  //   if(!isBrowser && window.ReactNativeWebView !== undefined)
  //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
  // }

  const handleOpenOrderList = useCallback(
    debounce(async (e: { preventDefault: () => void; }) => {
      e.preventDefault();
      if (loadOrder || disableButton) return;
      setDisableButton(true);
      setOpenOrderList(true);
      setOrderList({ loading: true } as any);
      await getCheckBill(tableInfo.id).then(
        (res) => {
          if (res.status === 200 || res.status === 201) {
            logger.debug(res.data);
            setOrderList({ loading: false } as any);
            setOrderList(res.data);
            // if(res.data && res.data.orderItems !== undefined) {
            //   setOpenOrderList(true)
            // } else 
              setOpenOrderList(true)
              // setLoadOrder(true);
              setDisableButton(false);
            logger.debug("order History");
          }
        },
        (error) => {
          logger.error("error", error);
        }
      );
      setDisableButton(false);
      // if (!isBrowser && window.ReactNativeWebView !== undefined) {
      //   window.ReactNativeWebView.postMessage(JSON.stringify({ 'type': 'play' }));
      // } else if(window.Android !== undefined) {
      //   window.Android.postMessage(JSON.stringify({'type':'play'}));
      // }
    }, 300),
    [loadOrder, disableButton, tableInfo.id, setOrderList]
  );

  const handleOpenServerCall = (e: React.TouchEvent<HTMLButtonElement> | React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault()
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    logger.debug('openServerCall')
    setOpenServerCall(true)

  }

  // useEffect(() => {
	// 	if(!loadOrder) return;
  //   setLoadOrder(false)

  //   console.log(orderList.hasOrder)
  //   if(orderList.hasOrder) {
  //     setSnackMode(4)
  //     setShowSnackbar(true)
  //     return
  //   } else {
  //     setSnackMode(7)
  //     setShowSnackbar(true)
  //     return
  //   } 

  // }, [loadOrder]);


  const handleOpenLanguageMenu = (e: React.TouchEvent<HTMLButtonElement> | React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    e.stopPropagation();
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    logger.debug('languagemenu')
    setOpenLanguageMenu(true)
  }

  return (
    <>
      <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flex: 1 , position: 'fixed',  bottom : 0, left: landMode? '25.4rem': '21.5rem', right: 0, padding: '0 1rem', zIndex: 99}}>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap : '1rem', alignItems: 'flex-end'}}>
                     <ActionButtons 
             isKiosk={isKiosk || false} 
             publicSettings={publicSettings} 
             isSettingsLoaded={isSettingsLoaded} 
             landMode={landMode} 
             handleOpenLanguageMenu={handleOpenLanguageMenu} 
             handleOpenServerCall={handleOpenServerCall} 
             handleOpenOrderList={handleOpenOrderList} 
           />
        </Box>
        {totalCount > 0 ?
          <Box sx={{ position: 'fixed', bottom : 0, right: '1rem', background: '#e5e5e5', height: landMode ? '7.6rem': '7rem',borderRadius : '1.5rem 1.5rem 0rem 0rem', width: landMode ?'28.9rem': '11.8rem', boxShadow: '0rem 0rem 2rem 0rem rgba(0, 0, 0, 0.35)'}}>
            <BlinkedBox style={{position: 'relative',  width: landMode ?'28.9rem': '11.8rem', height: landMode ? '7.6rem': '7rem' }}>
              <ButtonBase sx={{width: '100%', height: '100%', backgroundColor: '#F72E13', borderRadius : '1.5rem 1.5rem 0rem 0rem', textTransform: 'none',
                 display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}
                onClick={handleOpenCart} onTouchEnd={handleOpenCart}>
                  {landMode ? 
                    <>
                      <Typography sx={{color: '#fff', fontSize: '2.8rem', fontStyle: 'normal', fontWeight: '600', letterSpacing: '-.028rem', mb: 0, textWrap: 'nowrap', mr: '.5rem'}}>View cart</Typography>
                      <img style={{ width: '3.5rem', height: '3.4rem', marginRight: '.5rem'}}
                        src={process.env.PUBLIC_URL+'/assets/images/cart.svg'}
                        alt="cart"
                      />
                      {totalCount > 0 ? 
                        <>
                          <img style={{marginLeft: '0rem', width: '4.2rem', height: '4.2rem'}}
                            src={process.env.PUBLIC_URL+'/assets/images/ellipse_w.svg'}
                            alt="ellipse_w"
                          />
                          <Typography sx={{color: '#F72E13', fontSize: '1.8rem', fontStyle: 'normal', fontWeight: '600', letterSpacing: '-.018rem', mb: 0, textAlign: 'center', width: '3.5rem', ml: '-3.9rem'}}>{totalCount}</Typography>
                        </>: <></>
                      }
                    </>: 
                    <Stack sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                      <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                        <img style={{ width: '3.5rem', height: '3.4rem', marginRight: '.5rem'}}
                          src={process.env.PUBLIC_URL+'/assets/images/cart.svg'}
                          alt="cart"
                        />
                        {totalCount > 0 ? 
                          <Box sx={{position: 'relative', width: landMode ?'4.2rem': '3.4rem', height: landMode ?'4.2rem': '3.4rem'}}>
                            <img style={{ width: '100%', height: '100%'}}
                              src={process.env.PUBLIC_URL+'/assets/images/ellipse_w.svg'}
                              alt="ellipse_w"
                            />
                            <Typography sx={{
                              position: 'absolute', // 숫자를 원 위에 배치
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)', // 정중앙 정렬
                              color: '#F72E13',
                              fontSize: landMode ? '1.8rem' : '1.4rem',
                              fontWeight: '600',
                              letterSpacing: '-.018rem',
                              mb: 0,
                              textAlign: 'center',
                              whiteSpace: 'nowrap',
                            }}>{totalCount}</Typography>
                          </Box>: <></>
                        }
                      </Box>
                      <Typography sx={{color: '#fff', fontSize: landMode ?'2.8rem': '1.6rem', fontStyle: 'normal', fontWeight: '600', letterSpacing: '-.028rem', mb: 0, textWrap: 'nowrap'}}>View cart</Typography>
                    </Stack>}
              </ButtonBase>
            </BlinkedBox> 
          </Box>
          :
          <ButtonBase sx={[{ backgroundColor: '#F72E13', borderRadius : '1.5rem 1.5rem 0rem 0rem', boxShadow: '0rem 0rem 2rem 0rem rgba(0, 0, 0, 0.35)', textTransform: 'none',
          padding: '1.2rem 2.3rem', width: landMode ?'28.9rem': '11.8rem', display: 'flex', flexDirection: 'row',height: landMode ? '7.6rem': '7rem', alignItems: 'center', justifyContent: 'center', zIndex: 999}]}
            onClick={handleOpenCart} onTouchEnd={handleOpenCart}>
              {landMode ?
              <>
                <Typography sx={{color: '#fff', fontSize: '2.8rem', fontStyle: 'normal', fontWeight: '600', letterSpacing: '-.028rem', mb: 0, textWrap: 'nowrap', mr: '.5rem'}}>View cart</Typography>
                <img style={{width: '3.5rem', height: '3.4rem'}}
                  src={process.env.PUBLIC_URL+'/assets/images/cart.svg'}
                  alt="cart"
                />
              </> 
              : <Stack sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                  <img style={{width: '3.5rem', height: '3.4rem'}}
                    src={process.env.PUBLIC_URL+'/assets/images/cart.svg'}
                    alt="cart"
                  />
                  <Typography sx={{color: '#fff', fontSize: landMode ?'2.8rem': '1.6rem', fontStyle: 'normal', fontWeight: '600', letterSpacing: '-.028rem', mb: 0, textWrap: 'nowrap'}}>View cart</Typography>
              </Stack>}
          </ButtonBase>}
      </Box>  
    </>
  )
}
const modal = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '48rem',
  height: '29.6rem',
  bgcolor: 'background.paper',
  // border: '2px solid #fff',
	borderRadius: '1.5rem',
  boxShadow: '0rem 0rem 50rem 0rem rgba(0, 0, 0, 0.40)'

};
export default BottomMenu


